<template>
  <div>
    <div class="overlay-beacon" v-show="showPopup">
      <div class="overlay-popup">
        <div class="popup_text">
          <span class="popup_title">Apri il tornello</span>
          <span class="popup_text_detail">
            Prova ad aprire il tornello con
            <span style="color:#3890ce;">Life!</span>
          </span>
          <button class="apri_tornello" v-on:click="apriTornello">Apri</button>
        </div>
      </div>
    </div>

    <div v-if="test">
      <div class="buttons">
        <div class="button" v-on:click="pause=!pause">{{playPauseText}}</div>
        <div class="button" v-on:click="beaconResults=[]">CLEAR</div>
      </div>
      <div class="test">
        <div
          v-bind:class="{yellow: beacon.isnearest}"
          class="test-red"
          v-for="(beacon, idx) in beaconResults"
          v-bind:key="idx"
        >
          <h3>Minor : {{beacon.minor}}</h3>
          <div>Accuracy : {{beacon.accuracy}}</div>
          <div>Rssi : {{beacon.rssi}}</div>
          <div>proximity : {{beacon.proximity}}</div>
          <div>tx : {{beacon.tx}}</div>
          <div>data: {{beacon.data}}</div>
          <!--        <div>data: {{beacon.isnearest}}</div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '../config';
import tornelliUtil from '../services/TornelliUtil.service';
const cordova = window.cordova;
export default {
  name: 'BeaconReader',
  data() {
    return {
      test: false,
      results: [],
      beaconResults: [],
      lastOpen: 0,
      lastBeacon: null,
      pause: false,
      result: ''
    };
  },
  computed: {
    reservedResults() {
      return [].concat(this.results).reverse();
    },
    playPauseText() {
      return this.pause ? 'PLAY' : 'PAUSE';
    },
    showPopup() {
      let now = new Date().getTime() / 1000;
      console.log('now', now);
      if (now - this.lastOpen < 10) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    apriTornello() {
      console.log('APRO TORNELLO');
      this.lastOpen = 0;
      if (this.lastBeacon) {
        tornelliUtil
          .access(this.lastBeacon)
          .then(res => {
            console.log(res);
            this.result = JSON.stringify(res);
          })
          .catch(e => {
            console.error(e);
          });
      }
    }
  },
  mounted() {
    console.log('Beacon Reader');

    getPlugins().then(plugins => {
      const vm = this;
      initBackgroundMode();
      cordova.plugins.locationManager.enableDebugLogs();
      const delegate = new cordova.plugins.locationManager.Delegate();
      delegate.didDetermineStateForRegion = pluginResult => {
        console.log(pluginResult);
      };
      delegate.didStartMonitoringForRegion = pluginResult => {
        console.log(pluginResult);
      };
      delegate.didRangeBeaconsInRegion = pluginResult => {
        if (!vm.pause) {
          // vm.results.push(pluginResult);
          const resultBeacons = pluginResult.beacons;
          let distanceThreshold = 1.5;
          // const beaconRes = resultBeacons
          //   .filter(b => b.accuracy <= distanceThreshold)
          //   .sort((a, b) => a.accuracy - b.accuracy)[0];
          // if (beaconRes) {
          //   this.beaconResults.push(beaconRes);
          // }
          const beaconsInRange = resultBeacons.filter(
            b => b.accuracy <= distanceThreshold
          );
          if (beaconsInRange.length) {
            // const minor = beaconsInRange[0].minor;
            // tornelliUtil
            //   .access(minor)
            //   .then(res => {
            //     console.log(res);
            //     // alert(res);
            //   })
            //   .catch(e => {
            //     console.error(e);
            //   });
          }
          // if (beaconsInRange.length) {
          //   cordova.plugins.notification.local.schedule({
          //     title: 'There are a beacon in range',
          //     text: 'Thats pretty easy...'
          //   });
          // }
          const beaconOrderedByDistance = resultBeacons.sort(
            (a, b) => a.accuracy - b.accuracy
          );
          if (resultBeacons.length) {
            this.beaconResults = resultBeacons
              .sort((a, b) => a.minor - b.minor)
              .map(b => {
                b.data = parseInt(new Date().getTime() / 1000);
                b.isnearest =
                  beaconOrderedByDistance.length > 0
                    ? beaconOrderedByDistance[0].minor === b.minor
                    : false;
                return b;
              });

            let now = new Date().getTime() / 1000;

            if (now - this.lastOpen > 5) {
              this.lastOpen = now;
              this.beaconResults[0].data = 'APRO TORNELLO ' + this.lastOpen;
              this.lastBeacon = this.beaconResults[0].minor;
              tornelliUtil
                .access(this.beaconResults[0].minor)
                .then(res => {
                  console.log(res);
                  // alert(JSON.stringify(res));
                })
                .catch(e => {
                  console.error(e);
                });
            }
          }
        }
      };
      cordova.plugins.locationManager.setDelegate(delegate);
      cordova.plugins.locationManager.requestWhenInUseAuthorization();

      const beaconRegion = createBeaconRegion();
      // Start ranging.
      cordova.plugins.locationManager
        .startRangingBeaconsInRegion(beaconRegion)
        .fail(function(e) {
          console.error(e);
        })
        .done();

      // Start monitoring.
      // cordova.plugins.locationManager
      //   .startMonitoringForRegion(beaconRegion)
      //   .fail(function(e) {
      //     console.error(e);
      //   })
      //   .done();
    });
    refreshGetPlugins();
  }
};
/**
 * Function that creates a BeaconRegion data transfer object.
 *
 * @throws Error if the BeaconRegion parameters are not valid.
 */
function createBeaconRegion() {
  const uuid = config.BEACON_UUID; // mandatory
  const identifier = 'RdsBeacon-' + config.BEACON_UUID; // mandatory
  // var minor = 1000; // optional, defaults to wildcard if left empty
  // const major = 1; // optional, defaults to wildcard if left empty

  // throws an error if the parameters are not valid
  console.log('uuid', uuid);

  const beaconRegion = new cordova.plugins.locationManager.BeaconRegion(
    identifier,
    uuid
  );

  return beaconRegion;
}

let pluginsResolvers = [];
function refreshGetPlugins() {
  if (window.plugins) {
    getPlugins().then(console.log);
  } else {
    setTimeout(() => {
      getPlugins().then(console.log);
    }, 500);
  }
}
function getPlugins() {
  return new Promise((resolve, reject) => {
    if (!!!window.plugins) {
      pluginsResolvers.push(resolve);
    } else {
      for (let i = 0; i < pluginsResolvers.length; i++) {
        pluginsResolvers[i](window.plugins);
      }
      pluginsResolvers = [];
      resolve(window.plugins);
    }
  });
}
function initBackgroundMode() {
  cordova.plugins.backgroundMode.setDefaults({ hidden: true, silent: true });
  cordova.plugins.backgroundMode.enable();
}
</script>
<style lang="scss" scoped>
.test {
  border: gray solid 2px;
}
.test-red {
  border-top: red solid 1px;
  padding: 1px;
  &.yellow {
    background-color: yellow;
  }
  h3 {
    margin: 0;
  }
}
.test-red:nth-child(1) {
  border-top: none;
}
.buttons {
  display: flex;
}
.button {
  background-color: red;
  color: white;
  padding: 20px 0;
  width: 100%;
  text-align: center;
  border-left: white solid 1px;
  &:nth-child(1) {
    border-left: none;
  }
}
.overlay-beacon {
  background-color: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
}
.overlay-popup {
  background-image: url('../assets/images/beacon/background_tornello.svg');
  position: relative;
  width: 80%;
  height: calc(100% - 210px);
  z-index: 3;
  /*max-width: 442px;*/
  background-position: top;
  background-size: contain;
  background-repeat: no-repeat;
  /* left: 10%; */
  /*max-height: 330px;*/
  margin: 50px auto;
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
}
.img_chef {
  display: block;
  margin: 0 auto;
  width: 12%;
  max-width: 50px;
}
.popup_text {
  margin: 0 auto;
  margin-top: 45%;
  max-width: 500px;
  padding-top: 10px;
  text-align: center;
  color: #ffffff;
}
.popup_title {
  font-size: 1.07em;
  font-weight: 600;
  letter-spacing: 1px;
  display: block;
  line-height: 1.4;
  margin-bottom: 10px;
}
.popup_text_detail {
  margin-top: 30px;
  padding-right: 30px;
  padding-left: 30px;
  font-size: 1em;
  font-weight: 400;
  letter-spacing: 1px;
  display: block;
  line-height: 1.4;
  margin-bottom: 10px;
}
.apri_tornello {
  background-color: #ce182d;
  color: white;
  border: 0px;
  border-radius: 20px;
  height: 40px;
  width: 60%;
  margin-top: 40px;
}
</style>
